import { useMemo } from 'react';
import { useClientId } from '../../../_hooks/useClientId';
import { useBalanceSheetQuery } from '../../api/useBalanceSheetQuery';

export const useDetailNetWorth = () => {
  const clientId = useClientId();
  const queryInfo = useBalanceSheetQuery({ clientId });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { Summary, InEstateSummary, OutOfEstateSummary, EntityLevelSummaries } = queryInfo.data;

    return {
      summary: Summary,
      inEstateSummary: InEstateSummary,
      outOfEstateSummary: OutOfEstateSummary,
      entityLevelSummaries: EntityLevelSummaries,
    };
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
